import { ApplicationConfig, provideZoneChangeDetection, LOCALE_ID } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideHttpClientWithTranslate } from './http-translate.provider';

import { provideCacheableAnimationLoader, provideLottieOptions } from 'ngx-lottie';
import { BASE_PATH } from './core';
import { LanguageService } from './core/services/language/language.service';
import { LanguageRepository } from './core/services/language/language.repository';
import { environment } from 'environments/environment';

// Lazy-load lottie-web asynchronously with caching
let cachedPlayer: any = null;
const getLottiePlayer = async () => {
  if (!cachedPlayer) {
    const { default: player } = await import('lottie-web');
    cachedPlayer = player;
  }
  return cachedPlayer;
};

export const appConfig: ApplicationConfig = {
  providers: [
  provideHttpClient(withInterceptorsFromDi()),
    ...provideHttpClientWithTranslate(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideLottieOptions({ 
      player: () => getLottiePlayer()
    }),
    provideCacheableAnimationLoader(),
    provideAnimationsAsync(),
    { provide: BASE_PATH, useValue: environment.API_BASE_PATH },
    { provide: LanguageRepository, useClass: LanguageService }
  ]
};